import { Api } from 'viper';

const getSearchResults = (searchData) => {
  return Api.get(`/api/search?keyword=${searchData.searchString}`);
};

export default {
  getSearchResults
};
